module.exports = __webpack_public_path__ + "img/circle_rolling_animation.0d6ff72c.svg";